import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import { ProgressContext } from "../ContextAPI";
import axios from "axios";
import { Box, Typography } from "@mui/material";
import QuestionCard from "./FuturePlan/QuestionCard";
import ActionButtons from "./MaterialTopics/ActionButtons";
import { companyId } from "../../../utils/companyId";
import { api } from "../../../utils/api";
import { BorderColor } from "@mui/icons-material";
import { textError } from "../../../utils/validationMessage";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const Question = () => {
  const { setUpdate } = useContext(ProgressContext);
  const navigate = useNavigate();
  const [isExist, setIsExist] = useState(false);
  const companyDetails = getQuestionareSubmitted();

  const questions = [
    {
      question:
        "What do you perceive as the main challenges or barriers to implement sustainable practices within your company?",
      name: "challenges",
    },
    {
      question:
        " Are there any specific concerns or limitations regarding sustainability initiatives that your company faces?",
      name: "concerns",
    },
  ];

  const [formData, setFormData] = useState({
    challenges: "",
    concerns: "",
  });

  const [errors, setErrors] = useState({
    challenges: "",
    concerns: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${api}/company/challenges_and_concerns/${companyId}`
        );
        setFormData(response.data.challengesAndConcernsData);
        setIsExist(true);
      } catch (err) {
        console.error("Error:", err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "", // Clear the error when the user types
    });
  };

  const validateForm = () => {
    const newErrors = {
      challenges: "",
      concerns: "",
    };

    let isValid = true;

    if (!formData.challenges.trim()) {
      newErrors.challenges = textError;
      isValid = false;
    }

    if (!formData.concerns.trim()) {
      newErrors.concerns = textError;
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const Move = async () => {
    // if (!validateForm()) {
    //   return;
    // }

    try {
      const payload = {
        ...formData,
        companyId: companyId,
        challenges_concerns: false, // default value
      };

      const { challenges, concerns } = formData;
      const areFilled =
        challenges &&
        challenges.trim() !== "" &&
        concerns &&
        concerns.trim() !== "";

      if (areFilled) {
        payload.challenges_concerns = true;
      }
      await axios({
        method: isExist ? "put" : "post",
        url: `${api}/company/challenges_and_concerns${
          isExist ? `/${companyId}` : ""
        }`,
        data: payload,
      });
      navigate(
        companyDetails?.questionareSubmitted ? "/preview" : "/future-plans"
      );
    } catch (error) {
      console.log("Error:", error);
      alert("There was an error submitting the data!", error);
    }
  };

  const Back = () => {
    navigate("/sustainability");
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        sx={{
          p: 2,
          mt: 3,
          width: "75vw",
          height: "100vh", // Full viewport height
          overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to start at the top of the box
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              zIndex: 1,
              padding: "10px 0px",
              borderRadius: "4px",
              alignSelf: "flex-start",
              // ml: "5rem",
            }}
          >
            CHALLENGES & CONCERNS
          </Typography>
          <SkipQuestionare />
        </div>

        <Box sx={{ width: "80%" }}>
          {questions.map((item, index) => (
            <Box key={index} sx={{ mb: 3 }}>
              <QuestionCard
                question={item.question}
                name={item.name}
                value={formData[item.name]}
                onChange={handleChange}
                borderColor={errors[item.name] && "#D34040"}
              />
              {errors[item.name] && (
                <Typography variant="body2" color="#D34040" sx={{ mt: 1 }}>
                  {errors[item.name]}
                </Typography>
              )}
            </Box>
          ))}
          <ActionButtons
            Back={Back}
            Move={Move}
            disable={companyDetails?.questionareSubmitted}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Question;
